/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Fragment, useContext, useState } from "react";
import { TextField } from "@mui/material";
import { EntityContext } from "cms/entity/context";

const NumberEntityAttributeEditor = (props) => {

    const name = props.name;
    const value = props.value;

    const [number, setNumber] = useState(value);

    const entityContext = useContext(EntityContext);
    const updateAttribute = entityContext?.updateAttribute;

    const onChange = (event) => {
        const _number = event.target.value;
        setNumber(_number);
        updateAttribute(name, _number);
    };
    
    return (
        <Fragment>
            <div className="entity-attribute-editor-label">
                {name}
            </div>
            <div className="entity-attribute-editor-panel">
                {/* TODO: use number specific field */}
                <TextField
                    fullWidth={true}
                    defaultValue={number}
                    variant="outlined"
                    onChange={onChange}
                />
            </div>
        </Fragment>
    );
};

NumberEntityAttributeEditor.displayName = "NumberEntityAttributeEditor";
export { NumberEntityAttributeEditor };
